<template>
  <v-flex xs12 md4 style="background: #ececec; position: relative" class="pt-0 pl-8 pr-8 left-bar">
    <div v-if="tender">
      <v-card id="inform-block-card">
        <v-img
          :src="extractedImage"
          aspect-ratio="1"
          class="grey lighten-2"
          max-width="100%"
          max-height="30vh"
        >
        </v-img>
        <v-card-text style="position: relative; background: #d9d9d9" class="pa-2 pt-4">
          <v-fab-transition>
            <v-btn
              :color="isOpenTenderStarred ? 'amber darken-1' : 'white'"
              dark
              absolute
              top
              right
              fab
              @click="toggleStarredStatus(tender.id)"
            >
              <v-icon color="black">star</v-icon>
            </v-btn>
          </v-fab-transition>
          <h2 :title="tender.title" style="cursor: default" class="tender-detail-header">
            {{ substringText(tender.title, 100) }}
          </h2>
          <v-layout justify-space-between align-end class="mt-2">
            <v-flex md7>
              <span style="font-size: 13px">{{ categoryDescription }}</span>
            </v-flex>
            <v-flex md5 class="text-right">
              <span style="font-size: 16px" v-if="tender.value">
                {{ getFormatedValue(tender.value.amount, tender.value.currency) }}
              </span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="position: relative" class="pt-3 px-4">
          <v-layout>
            <div class="pr-8">
              <v-avatar size="55">
                <img src="@/assets/img/avatar.png" alt="John" />
              </v-avatar>
            </div>
            <v-flex v-if="tender.procuringEntity">
              <p>
                <translate tag="span">Published by</translate><br />
                <a href="#" @click.prevent="openOrgInfoDialog">{{ tender.procuringEntity.name }}</a>
              </p>
              <p v-if="tender.tenderPeriod">{{ tenderPeriod }}</p>
            </v-flex>
          </v-layout>
          <v-layout>
            <p>{{ tender.description }}</p>
          </v-layout>
          <TenderDetailTenderActions
            v-if="type === 'myTenders'"
            :getTender="getTender"
            :tender="tender"
          />
        </v-card-text>
      </v-card>
    </div>
    <div v-else class="choose-tender">
      <translate> Please choose a tender </translate>
      <br />
      <v-icon>touch_app</v-icon>
    </div>
  </v-flex>
</template>

<script>
import GlobalFunctions from '@/utils/GlobalFunctions'
import TenderDetailTenderActions from '@/components/app/tenders/tenderDetail/TenderDetailTenderActions'
import Vue from 'vue'
import starredMixin from '@/mixins/starredMixin'

export default {
  props: {
    tender: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    getTender: {
      type: Function,
      required: true,
    },
    categoryDescription: {
      type: String,
      required: true,
    },
  },

  components: {
    TenderDetailTenderActions,
  },

  mixins: [ starredMixin ],

  data() {
    return {
      isTenderAddedToFavorite: false,
    }
  },

  computed: {
    isOpenTenderStarred() {
      return this.tender.id && this.$store.state.starredTendersIds.includes(this.tender.id);
    },

    tenderPeriod() {
      if (this.tender && this.tender.tenderPeriod) {
        return Vue.moment(this.tender.tenderPeriod.endDate).format('ll')
      }

      return ''
    },
    extractedImage() {
      if (this.tender) {
        const category =
          this.type === 'prozorroTenders'
            ? this.tender.items[0].classification.id
            : this.tender.category

        return this.getImage(category)
      } else {
        return ''
      }
    },
  },

  methods: {
    openOrgInfoDialog() {
      this.$root.openOrganizationInfoDialog(this.tender.procuringEntity.identifier);
    },

    getImage(category) {
      if (!category) return ''
      if (this.findImage(category)) {
        return require('@/assets/img/tenderCpvImg/' + this.findImage(category))
      } else {
        return ''
      }
    },
    findImage(cpv) {
      return GlobalFunctions.findCpvImage(cpv).toString()
    },
    substringText(text, length) {
      return GlobalFunctions.substring(text, length)
    },
    getFormatedValue(value, currency) {
      return GlobalFunctions.toNumberFormat(value, currency)
    },
  },
}
</script>

<style lang="scss" scoped></style>
